import { put, call, fork, join, delay } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { moveCreatedItemToListAction } from '../actions/creatorActions'
import { setSlashActiveAction } from '../actions/landingActions'
import { setSnackbarErrorAction } from '../actions/snackbarActions'
import * as api from '../api'
import { Errno, getErrorMessage } from '../domain/Errno'
import { FETCH_LANDING_STATES } from '../reducers/landingReducer'
import { attemptRefreshToken } from './userSaga'

export function* createCreamItemSaga({ payload }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    // TODO [SWA-15] disable instalment feature
    payload.instalment = 0
    const { data } = yield call(api.requestCreateCreamItem, payload)

    yield put({
      type: types.SET_LANDING_FETCH_STATE,
      payload: FETCH_LANDING_STATES.FETCHED_IS_SELLER,
    })

    // * 1. lets CreateItemPage redirect to seller history page (by useEffect)
    yield put({
      type: types.CREATE_CREAM_ITEM_SUCCESS,
      payload: data,
    })

    // * 2. remove loading overlay
    yield put({ type: types.FETCH_COMPLETE })

    yield delay(100)

    // TODO [future] disable for now
    // // * 3. copy URL to clipboard and show snackbar message
    // try {
    //   yield call(clipboard.writeText, data.url)
    //   if (!isIOS) {
    //     yield put(setSnackbarAction({
    //       content: '連結已複製',
    //       color: 'black',
    //     }))
    //   }
    // } catch (ignored) {}

    // * 4. push animation
    // * see SellerHistoryReducer, SellerHistoryListPage, HistoryListTemplate, ItemTransitionWrapper
    yield put(moveCreatedItemToListAction(data))

    yield delay(1000)

    // * 5. mark item animation as finished, so animation won't show again
    // * see SellerHistoryReducer, SellerHistoryListPage
    yield put({ type: types.MARK_CREATED_ITEM_SHOWN })
  } catch (err) {
    console.error('createCreamItemSaga', err)
    if (err?.data?.errno === Errno.ERR_AIFIAN_PRODUCT_SERVICE_SLASH_INACTIVE) {
      yield put(setSlashActiveAction(false))
    }
    const message = getErrorMessage(err)
    yield put({ type: types.CREATE_CREAM_ITEM_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* terminateCreamItemSaga({ payload: itemId }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    yield call(api.requestTerminateCreamItem, itemId)
    yield put({
      type: types.TERMINATE_CREAM_ITEM_SUCCESS,
      payload: itemId,
    })
  } catch (err) {
    console.error('terminateCreamItemSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.TERMINATE_CREAM_ITEM_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getSlashInfoSaga() {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const res = yield call(api.requestGetSlashInfo)
    yield put({
      type: types.GET_SLASH_INFO_SUCCESS,
      payload: res.data,
    })
  } catch (err) {
    console.error('getSlashInfoSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.GET_SLASH_INFO_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}
